import React from "react";

const Razor_VB_Loops = () => {
  return (
    <div className="tutorial-page">
      <h1>Razor VB Loops</h1>
      <p>This is the Razor VB Loops page content.</p>
    </div>
  );
};

export default Razor_VB_Loops;
